// extracted by mini-css-extract-plugin
module.exports = {"pre-approved-offer":"pre-approved-offers_pre-approved-offer__bo_se","money-image":"pre-approved-offers_money-image__fhKHG"};